window.addEventListener('DOMContentLoaded', () => {
	const infos = document.querySelectorAll('.optionalInfo')

	infos.forEach(info => {
		const btn = info.querySelector('img.trigger')
		const tooltip = info.querySelector('.tooltip')

		btn?.addEventListener('click', e => {
			tooltip?.classList.toggle('open')
		})
	})
})
